import React from 'react';
import ReviewLayout from '../Templates/ReviewLayout';

const ManagerReviewTeam = () => {
    const verticalMenuItems = [
        { key: '1', title: 'ACE - Individual Awards', path: '/review/pm/individual' },
        { key: '2', title: 'ACE - Team Awards', path: '/review/pm/team' },
    ];

    return (
        <ReviewLayout
            subtitle="Manager Review"
            stage="3"
            stageName="Team Award Nominees"
            verticalMenuItems={verticalMenuItems}
            currentStage={1}
        />
    );
};

export default ManagerReviewTeam;
